/* src/app/features/prestacao-informacoes/atualizacao-informacoes-risco/atualizacao-info-risco-pesquisa.component.scss */
/*# sourceMappingURL=atualizacao-info-risco-pesquisa.component.css.map */
